import React from "react";
import "./index.css";
import { LockOutlined } from "@ant-design/icons";

const PermissionDenied = () => {
  return (
    <>
      <h3 className="permission-denied-title">
        {" "}
        Вашата регистрация е успешна!
      </h3>
      <LockOutlined className="permission-denied-icon" />
      <p className="permission-denied-text">
        Благодарим ви, че се регистрирахте в нашата платформа.
      </p>
      <p className="permission-denied-text">
        Вашият профил е успешно създаден и в момента чака одобрение от
        администратор.
      </p>
    </>
  );
};

export default PermissionDenied;
